/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessageSequenceStatus } from '../models/MessageSequenceStatus';
import type { WelcomeMessageApiV3OperationResponseDto } from '../models/WelcomeMessageApiV3OperationResponseDto';
import type { WelcomeMessageApiV3RequestDto } from '../models/WelcomeMessageApiV3RequestDto';
import type { WelcomeMessageConfigDto } from '../models/WelcomeMessageConfigDto';
import type { WelcomeMessageScope } from '../models/WelcomeMessageScope';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WelcomeMessagesService {
    /**
     * Find Welcome Message
     * Retrieves welcome message for a specific creator.
     * @returns WelcomeMessageApiV3OperationResponseDto Welcome message.
     * @throws ApiError
     */
    public static findOne({
        creatorId,
        scope,
        messageId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The scope of the welcome message (e.g., NEW_FANS, RETURNING_FANS).
         */
        scope: 'NEW_FANS' | 'RETURNING_FANS',
        messageId: number,
    }): CancelablePromise<WelcomeMessageApiV3OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}/{messageId}',
            path: {
                'creatorId': creatorId,
                'scope': scope,
                'messageId': messageId,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Creator or entity not found.`,
            },
        });
    }
    /**
     * Modify Welcome Message
     * Modifies an existing welcome message for a given scope and creator.
     * @returns WelcomeMessageApiV3OperationResponseDto Updated welcome message.
     * @throws ApiError
     */
    public static updateWelcomeMessage({
        creatorId,
        scope,
        messageId,
        requestBody,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The scope of the welcome message (e.g., NEW_FANS, RETURNING_FANS).
         */
        scope: 'NEW_FANS' | 'RETURNING_FANS',
        /**
         * Message id to be edited
         */
        messageId: number,
        /**
         * Details of the welcome message to be modified.
         */
        requestBody: WelcomeMessageApiV3RequestDto,
    }): CancelablePromise<WelcomeMessageApiV3OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}/{messageId}',
            path: {
                'creatorId': creatorId,
                'scope': scope,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized access.`,
                404: `Creator or message not found.`,
            },
        });
    }
    /**
     * Delete Welcome Message
     * Deletes a specific welcome message by its ID and scope.
     * @returns void
     * @throws ApiError
     */
    public static deleteWelcomeMessage({
        creatorId,
        messageId,
        scope,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The ID of the welcome message to delete
         */
        messageId: number,
        /**
         * The scope of the welcome message
         */
        scope: WelcomeMessageScope,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}/{messageId}',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
                'scope': scope,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Creator or message not found.`,
            },
        });
    }
    /**
     * Toggle Active/Inactive Welcome Message
     * Toggle Active/Inactive Welcome Message.
     * @returns any No data
     * @throws ApiError
     */
    public static toggleWelcomeMessageActivation({
        creatorId,
        scope,
        messageId,
        requestBody,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The scope of the welcome message (e.g., NEW_FANS, RETURNING_FANS).
         */
        scope: 'NEW_FANS' | 'RETURNING_FANS',
        /**
         * Message id to be edited
         */
        messageId: number,
        /**
         * Status should be applied to message sequence
         */
        requestBody: MessageSequenceStatus,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}/{messageId}/toggle-message',
            path: {
                'creatorId': creatorId,
                'scope': scope,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized access.`,
                404: `Creator or message not found.`,
            },
        });
    }
    /**
     * Get Global Welcome Messages Settings
     * Retrieves global welcome message settings for a specific creator.
     * @returns WelcomeMessageConfigDto Welcome message settings retrieved successfully.
     * @throws ApiError
     */
    public static getGlobalWelcomeMessageSettings({
        creatorId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
    }): CancelablePromise<WelcomeMessageConfigDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/settings',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Creator or settings not found.`,
            },
        });
    }
    /**
     * Update Global Welcome Message Settings
     * Updates global welcome message settings for a specific creator.
     * @returns WelcomeMessageConfigDto Welcome message settings updated successfully.
     * @throws ApiError
     */
    public static updateSettings({
        creatorId,
        requestBody,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * Details of the settings to be updated.
         */
        requestBody: WelcomeMessageConfigDto,
    }): CancelablePromise<WelcomeMessageConfigDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/settings',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input or missing required fields.`,
                403: `Unauthorized access.`,
                404: `Creator or settings not found.`,
            },
        });
    }
    /**
     * Find Welcome Messages
     * Retrieves all welcome messages for a given creator and scope.
     * @returns WelcomeMessageApiV3OperationResponseDto List of welcome messages.
     * @throws ApiError
     */
    public static findAllWelcomeMessages({
        creatorId,
        scope,
        sortBy,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The scope of the welcome message (e.g., NEW_FANS, RETURNING_FANS).
         */
        scope: 'NEW_FANS' | 'RETURNING_FANS',
        /**
         * Sorting criteria for the results (e.g., DEFAULT, SENT_TO, READS).
         */
        sortBy?: 'DEFAULT' | 'SENT_TO' | 'READS' | 'RESPONSES' | 'PPV_BOUGHT',
    }): CancelablePromise<Array<WelcomeMessageApiV3OperationResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}',
            path: {
                'creatorId': creatorId,
                'scope': scope,
            },
            query: {
                'sortBy': sortBy,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Creator not found.`,
            },
        });
    }
    /**
     * Create Welcome Message
     * Creates a new welcome message for a given scope and creator.
     * @returns WelcomeMessageApiV3OperationResponseDto Created welcome message.
     * @throws ApiError
     */
    public static createWelcomeMessageV3({
        scope,
        creatorId,
        requestBody,
    }: {
        /**
         * The scope of the welcome message (e.g., NEW_FANS, RETURNING_FANS).
         */
        scope: 'NEW_FANS' | 'RETURNING_FANS',
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * Details of the welcome message to be created.
         */
        requestBody: WelcomeMessageApiV3RequestDto,
    }): CancelablePromise<WelcomeMessageApiV3OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v3/settings/welcome-messages/{creatorId}/{scope}',
            path: {
                'scope': scope,
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input or missing required fields.`,
                403: `Unauthorized access.`,
                404: `Creator not found.`,
            },
        });
    }
}
